import useSessionStorage from "./useSessionStorage";

function useOAuthStateId() {
  const [stateId, SetStateId] = useSessionStorage("oauth_state_id");
  const params = new URLSearchParams(window.location.search);
  const newStateId = params.get("oauth_state_id");
  if (newStateId && newStateId !== stateId) {
    SetStateId(newStateId);
    return newStateId;
  }
  return stateId;
}

export default useOAuthStateId;
